<template>
  <div>
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="search-box mr-2 mb-4 mt-2">
      <div class="position-relative">
        <input type="text" class="form-control" v-model="filter.search" placeholder="Pesquise por Nome, E-mail ou CPF e pressione 'ENTER'" @keyup.enter="doSearch"/>
        <i class="bx bx-search-alt search-icon"></i>
      </div>
    </div>
    <div class="container-fluid custom-scroll" v-infinite-scroll="fetchPendingListPage" infinite-scroll-disabled="busyWaiting" infinite-scroll-distance="10">
      <div class="row row-item" v-for="item in waitingList" :key="'item-'+item.id">
        <div class="col texts-box text-truncate">
          <div class="text-1 text-truncate">{{ item.name }}</div>
          <div class="text-2 text-truncate">{{ item.email }}</div>
        </div>
        <div class="col-auto">
          <div class="fix-w">
            <b-button
              block
              variant="secondary"
            >
              Aguardando
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions } from 'vuex'
import infiniteScroll from 'vue-infinite-scroll'
import { errorMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading
  },
  directives: { infiniteScroll },
  props: {
    filters: {
      type: Object
    }
  },
  data () {
    return {
      loading: true,
      filter: {},
      busyWaiting: false,
      waitingList: [],
      paginationP: {
        currentPage: 0,
        total: 0,
        perPage: 20,
        totalPages: 0
      }
    }
  },
  created () {
    this.waitingList = []
    this.paginationP.currentPage = 0
    this.paginationP.total = 0
    this.paginationP.totalPages = null
    this.loadItem(this.filters)
  },
  methods: {
    ...mapActions('settingcheck', {
      getParticipantByTagPendingCheck: 'getParticipantByTagPendingCheck'
    }),
    loadItem (id) {
      if (id) {
        this.filter = { ...id }
        this.fetchPendingListPage()
      }
    },
    async fetchPendingListPage () {
      this.busyWaiting = true
      if (this.paginationP.totalPages === this.paginationP.currentPage) {
        this.busyWaiting = false
        return
      }
      try {
        const res = await this.getParticipantByTagPendingCheck(
          {
            page: this.paginationP.currentPage + 1,
            limit: this.paginationP.perPage,
            search: this.filter.search,
            tag: this.filter.tag,
            typeCheck: this.filter.typeCheck,
            checkin_date: this.filter.checkin_date ? this.$moment(this.filter.checkin_date).format('YYYY-MM-DD') : null
          }
        )
        this.paginationP.currentPage = res.meta.pagination.current_page
        this.paginationP.totalPages = res.meta.pagination.total_pages
        this.paginationP.total = res.meta.pagination.total
        this.waitingList.push(...res.data.map(item => ({ ...item, onAction: false })))
      } catch (error) {
        errorMessage('Erro ao carregar mais itens da lista pendente.')
        console.error('Erro:', error)
      } finally {
        this.busyWaiting = false
        this.loading = false
        this.$emit('loadWaitList', this.paginationP.total)
      }
    },
    doSearch () {
      this.resetList()
      this.fetchPendingListPage()
    },
    resetList () {
      this.waitingList = []
      this.paginationP.total = 0
      this.paginationP.currentPage = 0
      this.paginationP.totalPages = null
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "src/design/variables";
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.test-scroll {
  max-height: 300px;
  overflow-y: auto;
}
.custom-scroll{
  overflow-y: auto;
  max-height: 300px;
  padding-bottom: 0;
}
.fix-w {
  --width: 100px;
  --font-size: 13px;
  --icon-size: 16px;
  --btn-justify: space-evenly;
  --btn-padding: 0.20rem 0.08rem;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --width: 100px;
    --font-size: 13px;
    --icon-size: 16px;
    --btn-justify: space-around;
    --btn-padding: 0.20rem 0.35rem;
  }

  width: var(--width);

  button {
    font-size: var(--font-size);
    display: flex;
    align-items: center;
    justify-content: var(--btn-justify);
    padding: var(--btn-padding);

    i {
      font-size: var(--icon-size);
    }
  }
}

.row-item {
  --padding: 10px 5px;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --padding: 9px 5px;
  }
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 16px;
  padding: var(--padding);
  border: 1px solid rgba(233, 233, 233, 0.59);
  align-items: center;
  cursor: pointer;
}
.texts-box {
  .text-1 {
    font-size: 14px;
    color: #05162B;
  }

  .text-2 {
    font-size: 12px;
    color: #05162B87;
  }
}
</style>
